// 完善企业信息

import { useState, useEffect } from 'react'
import { message, Form, Input, Button, Modal, Carousel, Select } from 'antd'
import fun from '../../common/common_fun'
import url from '../../common/url_config'
import { UserOutlined, LockOutlined, SearchOutlined } from '@ant-design/icons';
import cookie from 'react-cookies'
import huijv from './../../common/huijv'
import common_data from '../../common/common_data';

const { Option } = Select

let job_title_set = [
  { name_en: 'Academic experts', name_ch: '学术专家' },
  { name_en: 'Student', name_ch: '学生' },
  { name_en: 'Hardware Engineer', name_ch: '硬件工程师' },
  { name_en: 'Software Engineer', name_ch: '软件工程师' },
  { name_en: 'System architect', name_ch: '系统架构师' },
  { name_en: 'Field Application Engineer', name_ch: '现场应用工程师' },
  { name_en: 'Market', name_ch: '市场' },
  { name_en: 'Project manager', name_ch: '项目经理' },
  { name_en: 'Procurement/Supply Management', name_ch: '采购/供应管理' },
  { name_en: 'Quality', name_ch: '质量' },
  { name_en: 'Sale', name_ch: '销售' },
  { name_en: 'Other', name_ch: '其他' },
]

let industry_set = [
  { name_en: 'Industry', name_ch: '工业' },
  { name_en: 'Automotive Electronics', name_ch: '汽车电子' },
  { name_en: 'Communication network', name_ch: '通信网络' },
  { name_en: 'Connectivity', name_ch: '无线连接' },
  { name_en: 'Consumer Electronics', name_ch: '消费电子' },
  { name_en: 'Medical treatment', name_ch: '医疗' },
  { name_en: 'Mobile communication', name_ch: '移动通讯' },
  { name_en: 'Smart Home', name_ch: '智能家居' },
  { name_en: 'Distributor', name_ch: '分销商' },
  { name_en: 'Electronic manufacturing service industry', name_ch: '电子制造服务业' },
  { name_en: 'Tool Provider', name_ch: '工具提供商（RTOS, H/W, S/W）' },
  { name_en: 'Scheme designer', name_ch: '方案设计商' },
  { name_en: 'Media/Analyst', name_ch: '媒体/分析师' },
  { name_en: 'College institutions', name_ch: '学院机构' },
  { name_en: 'Government', name_ch: '政府' },
  { name_en: 'Other', name_ch: '其它' },
]

const company_info_set = [
  {
    key: 'industry',
    name: '公司行业',
    name_en: 'Industry',
    type: 'enum',
    enum_set: industry_set,
  },
  {
    key: 'job_title',
    name: '职务',
    name_en: 'Job Title',
    type: 'enum',
    enum_set: job_title_set,
  },
]

function App(props: any) {
  let [my_co_info, set_my_co_info] = useState({
    company: '', company_en: '', mobile: '',
    province: '', city: '',
    industry: '', job_title: '',
    is_mainland_China: true
  })//完善企业信息
  let [loading, set_loading] = useState(false)//加载中
  let [key_word, set_key_word] = useState('')//加载中
  let [company_set, set_company_set] = useState([])//查询到的公司集合
  let [qichacha_return_info, set_qichacha_return_info] = useState({ 'name': '' })//已选企查查信息
  let [data_end, set_data_end] = useState(false)//数据是否加载完毕 
  let [page_index, set_page_index] = useState(1)//当前页码
  let [city_set_by_pro, set_city_set_by_pro] = useState([])//城市集合
  let [old_company_name, set_old_company_name] = useState('')//原公司名称
  let send_code_time = 60
  let [sending_code, set_sending_code] = useState(false)//是否在发送验证码
  let [current_time, set_current_time] = useState(send_code_time)//倒计时
  let [real_mobile, set_real_mobile] = useState('')//真实发送信息的手机号
  let [code, set_code] = useState('')//验证码
  let [current_language_ch, set_current_language_ch] = useState(window.location.href.indexOf('?lan=en') === -1)//当前语言是否中文

  // 更新个人公司信息
  const update_my_co_info = () => {
    let sub_company_info = { ...my_co_info, company: qichacha_return_info.name || old_company_name, mobile: real_mobile }
    // let sub_company_info = { ...my_co_info, company: key_word || qichacha_return_info.name || old_company_name, mobile: real_mobile }//20250521避免起查查额度，先不使用选择公司
    console.log(sub_company_info, qichacha_return_info)
    // 内地用户填写手机号码及公司名称
    if (sub_company_info.is_mainland_China) {
      if (!sub_company_info.company) {
        message.error(current_language_ch ? '请选择正确的公司名称' : 'Please select the correct company')
        return
      }
      if ((!sub_company_info.mobile || sub_company_info.mobile.length < 11) || !code) {
        message.error(current_language_ch ? '请填写正确的手机号码和短信验证码' : 'Please fill in the correct phone number and the code')
        return
      }
      if ((!sub_company_info.province || !sub_company_info.city)) {
        message.error(current_language_ch ? '省份和城市是必填的' : 'Province and city are neccessary')
        return
      }
    }

    // 必填项校验
    if (!sub_company_info.industry || !sub_company_info.job_title || !sub_company_info.company_en) {
      message.error(current_language_ch ? '请补充全部信息' : 'Please provide all necessary information')
      return
    }

    huijv.c_cloud_lab_c_update_info(sub_company_info.company, sub_company_info.mobile, sub_company_info.job_title)

    // return
    set_loading(true)
    fun['post_data'](url + 'update_my_co_info_width_mobile', { ...sub_company_info, qichacha_return_info, code }).then(res => {
      if (res.status) {
        // message.success(current_language_ch ? '更新信息成功' : 'Update Successfully')
        props.close_modal()
      } else {
        alert(JSON.stringify(current_language_ch ? res.result : (res.result_en || res.result)))
      }
      set_loading(false)
    })
  }



  // 搜索事件
  const handleSearchValue = huijv.useDebounce((e: any) => { // 获取input的值
    set_company_set([])
    set_qichacha_return_info({ 'name': '' })
    const value = e.target.value
    if (value && value.length >= 2) {
      console.log('搜索公司信息关键词', value)
      set_loading(true)
      fun['post_data'](url + 'get_qichacha_company_set', { key_word: value, pageIndex: 1 }).then(res => {
        if (res.status) {
          console.log('查询到的公司集合', res.result)
          set_company_set(res.result)
        } else {
          message.warning(JSON.stringify(current_language_ch ? res.result : (res.result_en || res.result)))
        }
        set_loading(false)
      })
    }
  }, 700)

  // 根据省份获取城市
  const get_city_by_province = (province: string) => {
    let pro_return = ''
    let ProID = 0
    let temp_city_set_by_pro: any = []
    for (let i in common_data.province_set) {
      let item = common_data.province_set[i]
      if (item['name'].indexOf(province) !== -1) {
        pro_return = item['name']
        ProID = item['ProID']
        break
      }
    }
    if (ProID > 0) {
      for (let i in common_data.city_set) {
        let item = common_data.city_set[i]
        if (item['ProID'] === ProID) {
          temp_city_set_by_pro.push(item)
        }
      }
    }
    console.log(temp_city_set_by_pro)
    set_city_set_by_pro(temp_city_set_by_pro)
    return pro_return
  }

  useEffect(() => {
    console.log(props.my_co_info,)
    let province = props.my_co_info.province
    let city = props.my_co_info.city
    if (province) {
      province = get_city_by_province(province)
    }
    if (city) {
      for (let i in common_data.city_set) {
        let item = common_data.city_set[i]
        if (item['name'].indexOf(city) !== -1) {
          city = item['name']
        }
      }
    }
    if (props.my_co_info.company) {
      set_old_company_name(props.my_co_info.company)
    }
    set_my_co_info({
      ...props.my_co_info,
      //  industry: '', job_title: '', 
      province, city
    })
  }, [])

  useEffect(() => {
    setTimeout(() => {
      if (sending_code) {
        set_current_time(current_time - 1)
      }
    }, 1000)
  }, [current_time, sending_code])

  return (
    <div style={{ paddingTop: 0 }} >
      {/* 补充信息 */}
      {!props.is_only_confirm_info && <h3 style={{ marginBottom: 0, textAlign: 'center', fontWeight: 'bold', color: '#f50', fontFamily: 'PoppinsBold' }}>
        {(props.my_co_info.mobile && !props.my_co_info.send_sms_code_time) ?
          (current_language_ch ? '请点击发送验证码来验证您的手机号码，进行下一步' : 'Please click to send verification code to verify your phone number, and to the next step') :
          (current_language_ch ? '请补充以下信息后，进行下一步' : 'Please provide the following information before proceeding to the next step')}
      </h3>}

      {/* 仅确认信息 */}
      {props.is_only_confirm_info && <h3 style={{ marginBottom: 0, textAlign: 'center', fontWeight: 'bold', color: '#f50', fontFamily: 'PoppinsBold' }}>{current_language_ch ? '请确认是否需要变更信息' : 'Please confirm if there is a need to change the information'}</h3>}

      {/* 仅内地用户展示 */}
      {/* 公司中文名称 */}
      {my_co_info.is_mainland_China && <>
        {/* 搜素公司输入框/按钮 */}
        <Input placeholder={old_company_name ? old_company_name : (current_language_ch ? '输入不小于2个字符' : 'Please enter no less than 2 characters')}
          style={{ marginTop: 10 }} addonBefore={current_language_ch ? '公司中文名称' : 'Company Name'}
          allowClear onChange={(e: any) => {
            set_key_word(e.target.value)
            handleSearchValue(e)
          }} value={key_word} />

        {/* 搜索公司列表 */}
        {company_set.length > 0 && <div style={{ maxHeight: 200, overflowY: 'auto', border: '1px solid #dddddd', borderTop: 'none' }}>
          {/* <div>{current_language_ch ? '请从下面列表中点击选择您的公司' : 'Please click to select your company from the list below'}</div> */}
          {company_set.map((item: any, index: number) => <div style={{ margin: 3, cursor: 'pointer' }} key={index} onClick={() => {
            set_qichacha_return_info(company_set[index])

            let temp: any = { ...my_co_info }
            temp['company'] = item.name
            set_key_word(item.name)
            set_my_co_info(temp)
          }}>{item['name']}</div>)}
        </div>}
        {/* 继续加载按钮 */}
        {/* <div style={{ textAlign: 'center', marginTop: 3 }}>{data_end ? <span>{current_language_ch ? '数据加载完毕' : 'Data loading completed'}</span> : <Button onClick={() => search_company(page_index + 1)} disabled={loading || company_set.length === 0} type='primary' size='small'>{current_language_ch ? '继续加载' : 'Load more'}</Button>}</div> */}
        {/* 当前已选 */}
        {/* <div style={{ marginTop: 5 }}>当前已选：{my_co_info['company']}</div> */}
      </>}

      {/* 公司英文名称 */}
      <Input onPressEnter={() => update_my_co_info()} style={{ marginTop: 10 }} addonBefore={current_language_ch ? '公司英文名称' : 'Company En Name'} allowClear onChange={(e: any) => {
        let temp: any = { ...my_co_info }
        temp['company_en'] = e.target.value
        set_my_co_info(temp)
      }} value={my_co_info['company_en']} />

      {/* 仅内地用户展示 */}
      {my_co_info.is_mainland_China && <>
        {/* 手机号码 */}
        <Input
          placeholder={current_language_ch ? '请填写正确的手机号码' : 'Please fill in the correct phone number'}
          onPressEnter={() => update_my_co_info()} style={{ marginTop: 10 }} addonBefore={current_language_ch ? '手机号码' : 'Mobile'} allowClear onChange={(e: any) => {
            let temp: any = { ...my_co_info }
            temp['mobile'] = e.target.value
            set_my_co_info(temp)
          }} value={my_co_info['mobile']} />

        {/* 验证码 */}
        <Input
          style={{ marginTop: 10 }}
          addonBefore={<div>{current_language_ch ? '短信验证码' : 'SMS Code'}</div>}
          addonAfter={<span onClick={() => {
            if (sending_code) {
              message.warn(current_language_ch ? '请倒计时结束后重新发送' : 'Please resend after the countdown ends')
              return
            }
            let mobile = String(my_co_info.mobile)
            if (!mobile || mobile.length !== 11) {
              message.error(current_language_ch ? '请输入正确的手机号码' : 'Please enter the correct phone number')
              return
            }
            set_loading(true)
            fun['post_data'](url + 'send_sms_code_for_update_my_co_info', { mobile }).then(res => {
              if (res.status) {
                set_real_mobile(mobile)
                message.success(current_language_ch ? '发送成功，15分钟内有效' : 'Sent successfully, valid within 15 minutes')

                set_sending_code(true)
                set_current_time(send_code_time)
                let t = setTimeout(() => {
                  set_sending_code(false)
                  set_current_time(send_code_time)
                }, 1000 * send_code_time)
              } else {
                alert(JSON.stringify(current_language_ch ? res.result : (res.result_en || res.result)))
              }
              set_loading(false)
            })
          }} style={{ cursor: 'pointer' }}>{current_language_ch ?
            (loading ? '加载中' : (sending_code ? (current_time + 's后重新发送') : '点击发送验证码')) :
            (loading ? 'Loading' : (sending_code ? ('Resend in ' + current_time + ' seconds') : 'Click to send code'))}</span>}
          type="number"
          onPressEnter={() => update_my_co_info()}
          placeholder={current_language_ch ? "短信验证码" : 'SMS Code'}
          value={code}
          onChange={e => set_code(e.target.value)}
        />

        {/* 省份 */}
        <span style={{ marginTop: 7, display: 'inline-block', width: '100%' }}>
          <span style={{}} className='select_before'>{current_language_ch ? '省份' : 'Province'}</span>
          <Select showSearch style={{ width: 'calc(100% - 152px)' }} placeholder={current_language_ch ? '省份' : 'Province'} onChange={e => {
            let temp: any = { ...my_co_info }
            temp['province'] = e
            temp['city'] = ''
            set_my_co_info(temp)
            get_city_by_province(e)
          }} value={my_co_info['province']}>
            {common_data.province_set.map((item2: any) => <Option key={item2.name} value={current_language_ch ? item2.name : item2.name}>{current_language_ch ? item2.name : item2.name}</Option>)}
          </Select>
        </span>

        {/* 城市 */}
        {/* <Input onPressEnter={() => update_my_co_info()} style={{ marginTop: 10 }} addonBefore={current_language_ch ? '城市' : 'City'} allowClear onChange={(e: any) => {
          let temp: any = { ...my_co_info }
          temp['city'] = e.target.value
          set_my_co_info(temp)
        }} value={my_co_info['city']} /> */}
        {city_set_by_pro.length > 0 && <span style={{ marginTop: 7, display: 'inline-block', width: '100%' }}>
          <span style={{}} className='select_before'>{current_language_ch ? '城市' : 'City'}</span>
          <Select showSearch style={{ width: 'calc(100% - 152px)' }} placeholder={current_language_ch ? '城市' : 'City'} onChange={e => {
            let temp: any = { ...my_co_info }
            temp['city'] = e
            set_my_co_info(temp)
          }} value={my_co_info['city']}>
            {city_set_by_pro.map((item2: any) => <Option key={item2.name} value={current_language_ch ? item2.name : item2.name}>{current_language_ch ? item2.name : item2.name}</Option>)}
          </Select>
        </span>}

      </>}

      {/* 其他 */}
      {company_info_set.map((item: any) => {
        return <span style={{ marginTop: 7, display: 'inline-block', width: '100%' }} key={item.key}>
          <span style={{}} className='select_before'>{current_language_ch ? item.name : item.name_en}</span>
          <Select showSearch style={{ width: 'calc(100% - 152px)' }} placeholder={current_language_ch ? item.name : item.name_en} onChange={e => {
            let temp: any = { ...my_co_info }
            temp[item.key] = e
            console.log(temp)
            set_my_co_info(temp)
          }} value={my_co_info[item.key] || ''}>
            {item.enum_set.map((item2: any) => <Option key={item2.name_ch} value={current_language_ch ? item2.name_ch : item2.name_en}>{current_language_ch ? item2.name_ch : item2.name_en}</Option>)}
          </Select>
        </span>
      })}
      <Button style={{ marginTop: 10, width: '100%' }} loading={loading} type='primary' onClick={() => update_my_co_info()}>{props.is_only_confirm_info ? (current_language_ch ? '确认更新信息' : 'Confirm update information') : (current_language_ch ? '提交' : 'SUBMIT')}</Button>
      {props.is_only_confirm_info && <Button style={{ marginTop: 10, width: '100%' }} loading={loading} onClick={() => {
        set_loading(true)
        fun['post_data'](url + 'update_my_co_info_only_confirm', {}).then(res => {
          if (res.status) {
            props.close_modal()
          } else {
            alert(JSON.stringify(current_language_ch ? res.result : (res.result_en || res.result)))
          }
          set_loading(false)
        })
      }}>{(current_language_ch ? '暂不更新信息' : 'Do not update the information')}</Button>}
    </div>
  )
}

export default App